<h3>Welcome to the WorkBench</h3>

<p>A place to test new features away from the rest of the team.</p>

<div class="row row-cols-1">
  <div class="col">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">Manage Integration Credentials:</h5>
        <div class="table-responsive" style="overflow: visible">
          <table class="table" mdbTable hover="true" small="true" stickyHeader="true">
            <thead>
              <tr>
                <th>Id</th>
                <th>Name</th>
                <th>User Name</th>
                <th>Password</th>
                <th>SessionId</th>
                <th>SessionId Created Date</th>
                <th>Days valid for</th>
                <th scope="col" class="text-center">Enabled</th>
                <th scope="col" class="text-center">Last used</th>
                <th scope="col" class="text-center">Refresh count</th>
                <th scope="col" class="text-center">Save</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let credential of integrationCredentials"
                [ngClass]="{
                  'update-success': credential.recentlyUpdated,
                  'update-fail': credential.error
                }"
              >
                <td>
                  {{ credential.id }}
                </td>
                <td>{{ credential.integrationName }}</td>
                <td (click)="editField(credential, 'userName')">
                  <span *ngIf="!editMode || credential !== editedCredential || !editableUserName">
                    {{ credential.userName }}
                  </span>
                  <input
                    *ngIf="editMode && credential === editedCredential && editableUserName"
                    type="text"
                    [(ngModel)]="credential.userName"
                  />
                </td>
                <td (click)="editField(credential, 'newPassword')">
                  {{ credential.password }}

                  <div *ngIf="editMode && credential === editedCredential">
                    <input type="text" [(ngModel)]="credential.newPassword" placeholder="New Password" />
                  </div>
                </td>
                <td>
                  {{ credential.sessionId }}
                </td>
                <td>
                  {{ credential.sessionIdCreated }}
                </td>
                <td>
                  {{ credential.daysValidFor }}
                </td>
                <td class="text-center">
                  <mdb-checkbox
                    [(ngModel)]="credential.isEnabled"
                    class="mt-2"
                    name="isEnabled"
                    (click)="editField(credential, 'isEnabled')"
                  >
                  </mdb-checkbox>
                </td>
                <td>{{ credential.lastUsed }}</td>

                <td class="text-center" (click)="editField(credential, 'refreshCount')">
                  <span *ngIf="!editMode || credential !== editedCredential">
                    {{ credential.refreshCount }}
                  </span>
                  <input *ngIf="editMode && credential === editedCredential" type="text" [(ngModel)]="credential.refreshCount" />
                </td>

                <td class="text-center">
                  <span *ngIf="!credential.isUpdating; else busySpinner">
                    <button
                      size="sm"
                      class="btn-trakly-action"
                      *ngIf="editMode && credential === editedCredential"
                      (click)="saveRecord(credential)"
                    >
                      Save
                    </button>
                  </span>
                  <ng-template #busySpinner>
                    <div class="spinner-grow text-primary small-spinner" size="sm" role="status">
                      <span class="sr-only" role="status">Loading...</span>
                    </div>
                  </ng-template>

                  <span *ngIf="credential.updateSuccess">
                    <mdb-icon fas icon="circle-check" class="action-icon"></mdb-icon>
                  </span>
                  <span *ngIf="credential.error">
                    <mdb-icon fas icon="circle-xmark" class="action-icon sortable"></mdb-icon>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<app-add-new-trade></app-add-new-trade>
<error-component [error]="pageError" [(showModal)]="showError"></error-component>
